// src/components/features/analysis/CommentsSection.jsx
import React, { useState } from 'react';
import { apiService } from '../../../services/api';

const CommentsSection = ({ sha256, comments, commentsLoading, onCommentAdded }) => {
  const [text, setText] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setSubmitting(true);
    setError('');
    try {
      const newComment = await apiService.addComment(sha256, text.trim());
      onCommentAdded(newComment);
      setText('');
    } catch {
      setError('Failed to post comment. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0, fontSize: '1rem', fontWeight: '600', color: '#111827' }}>
          Analyst Notes
        </h3>
        <span style={{
          background: '#e0e7ff', color: '#3730a3',
          borderRadius: '9999px', padding: '0.1rem 0.55rem',
          fontSize: '0.78rem', fontWeight: '600',
        }}>
          {comments.length}
        </span>
      </div>

      {/* Comment list */}
      {commentsLoading ? (
        <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Loading...</p>
      ) : comments.length === 0 ? (
        <p style={{ color: '#6b7280', fontSize: '0.9rem', marginBottom: '1.5rem' }}>No notes yet.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1.5rem' }}>
          {comments.map((c) => (
            <div
              key={c.id}
              style={{
                background: 'white', border: '1px solid #e5e7eb',
                borderRadius: '8px', padding: '0.9rem 1rem',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.4rem' }}>
                <span style={{ fontWeight: '600', fontSize: '0.85rem', color: '#374151' }}>
                  {c.author.split('@')[0]}
                </span>
                <span style={{ fontSize: '0.78rem', color: '#9ca3af' }}>
                  {new Date(c.timestamp).toLocaleString()}
                </span>
              </div>
              <p style={{
                margin: 0, fontSize: '0.875rem', color: '#4b5563',
                whiteSpace: 'pre-wrap', lineHeight: '1.5',
              }}>
                {c.text}
              </p>
            </div>
          ))}
        </div>
      )}

      {/* Add note form */}
      <form onSubmit={handleSubmit}>
        <textarea
          value={text}
          onChange={e => setText(e.target.value)}
          placeholder="Add a note..."
          rows={4}
          maxLength={2000}
          style={{
            width: '100%', padding: '0.6rem 0.75rem',
            border: '1px solid #d1d5db', borderRadius: '6px',
            fontSize: '0.875rem', resize: 'vertical',
            fontFamily: 'inherit', boxSizing: 'border-box',
            outline: 'none',
          }}
        />
        {error && (
          <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '0.3rem 0 0' }}>{error}</p>
        )}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '0.5rem' }}>
          <button
            type="submit"
            disabled={!text.trim() || submitting}
            style={{
              padding: '0.45rem 1.1rem', background: '#3b82f6', color: 'white',
              border: 'none', borderRadius: '6px', cursor: 'pointer',
              fontSize: '0.875rem', fontWeight: '500',
              opacity: (!text.trim() || submitting) ? 0.5 : 1,
            }}
          >
            {submitting ? 'Posting...' : 'Post Note'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CommentsSection;
